import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import env from '../utils/env';

const HTML_CLASSLIST = document.documentElement.classList;

const ClassName = {
	NO_SCROLL: '_no-scroll',
};

class Scroll {
	disabled(container) {
		if (!env.isIOS) {
			disableBodyScroll(container);
			document.body.style.overflow = 'hidden';
		}
		if (env.isIOS) {
			document.body.style.overflow = 'hidden';
		}
		HTML_CLASSLIST.add(ClassName.NO_SCROLL);
	}
	enabled(container) {
		if (!env.isIOS) {
			enableBodyScroll(container);
			document.body.style.overflow = '';
		}
		if (env.isIOS) {
			document.body.style.overflow = '';
		}

		HTML_CLASSLIST.remove(ClassName.NO_SCROLL);
	}
}

export default new Scroll();
